import React from 'react';
import { medsCreateState, createMedsStep } from 'store/storeValtio';

export default function MedicationEveryNDays({ prevStep, nextStep }) {
  //console.log('MedicationEveryNDays');

  function handleClick(days) {
    //console.log('handleClick', days);
    //const hr = hrs > 1 ? ' days' : ' day';
    //const often = `Every ${hrs}${hr}`;
    medsCreateState.often = 'everyndays';
    medsCreateState.occurance = days;
    medsCreateState.schedule = [];
    nextStep(createMedsStep.schedule);
}

  const days = [];
  for (let i = 2; i < 7; ++i) {
    const hr = i > 1 ? ' days' : ' day';
    let cn = 'rawBtn w-full h-8 p-0 border-2 border-gray-400 text-sm text-blue';
    cn += (i === medsCreateState.occurance) ? " bg-green-300" : " bg-blue-300" ;
    days.push(
      <li key={i} className={'snap-start scroll-m-0 p-0 m-0'}>
        <button
          onClick={()=>handleClick(i)}
          className={cn}
        >
          {i}{hr}
        </button>
      </li>
    );
  }

  return (
    <div className='flex flex-col'>
      <div className='medBody text-center'>
        How many days are there between your doses?
      </div>
      <div className='mcard'>
        <div className='px-4 flex justify-center'>
          <ul className='w-96 h-[288px] snap-y snap-mandatory overflow-x-hidden overflow-y-scroll'>
              {days}
          </ul>
        </div>
      </div>
    </div>
  );
}
